export const RECAPTCHA = "6Le27v0UAAAAAOVPMW_YHMzabN7dbQKMktj9y02r";
export const LORO = "https://admin.pc.sdc.gal";